import { motion } from 'framer-motion';

export default function TrustedBySection() {
  const logos = [
    {
      name: "Smart Sold Realty",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/ssr.jpeg",
      alt: "Smart Sold Realty Logo"
    },
    {
      name: "eXp Realty",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/exp.png",
      alt: "eXp Realty Logo"
    },
    {
      name: "RE/MAX",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/remax.jpeg",
      alt: "RE/MAX Logo"
    },
    {
      name: "RE/MAX Commercial",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/remax commercial.png",
      alt: "RE/MAX Commercial Logo"
    },
    {
      name: "Pricelock Realty",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/pricelock.png",
      alt: "Pricelock Realty Logo"
    },
    {
      name: "CPW",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/CPW.png",
      alt: "CPW Logo"
    },
    {
      name: "Epique Realty",
      url: "https://cdn.jsdelivr.net/gh/Pointbreakinc/pbsite@main/epique.png",
      alt: "Epique Realty Logo"
    }
  ];

  return (
    <section className="relative pt-8 sm:pt-12 pb-8 sm:pb-20 bg-white overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-50" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4a10d]/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4a10d]/20 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5 sm:mb-12"
        >
          <h2 className="text-sm sm:text-base font-bold tracking-[0.2em] text-[#d4a10d] uppercase mb-2">
            Trusted By
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 font-medium">
            Leading real estate companies building with Point Break Systems
          </p>
        </motion.div>

        <div className="relative">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 sm:gap-8 items-center justify-items-center"
          >
            {logos.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative w-full"
              >
                <div className="relative bg-white border border-gray-200 rounded-xl p-3 sm:p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:border-[#d4a10d]/30 hover:-translate-y-1">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#d4a10d]/0 to-[#d4a10d]/0 group-hover:from-[#d4a10d]/5 group-hover:to-[#d4a10d]/10 rounded-xl transition-all duration-300" />

                  <div className="relative flex items-center justify-center h-10 sm:h-20">
                    <img
                      src={logo.url}
                      alt={logo.alt}
                      className="max-h-full max-w-full w-auto h-auto object-contain grayscale group-hover:grayscale-0 opacity-60 group-hover:opacity-100 transition-all duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="text-center mt-5 sm:mt-12"
        >
          <p className="text-sm text-gray-500 italic">
            Real estate teams across Canada and the United States, calling every lead in under 30 seconds
          </p>
        </motion.div>
      </div>
    </section>
  );
}

